import { render, staticRenderFns } from "./MessageTemplatesGuide.vue?vue&type=template&id=3ab5e1fd&scoped=true"
import script from "./MessageTemplatesGuide.vue?vue&type=script&lang=js"
export * from "./MessageTemplatesGuide.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplatesGuide.vue?vue&type=style&index=0&id=3ab5e1fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab5e1fd",
  null
  
)

export default component.exports